import '@babel/polyfill'
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vue2TouchEvents from "vue2-touch-events";
import VueScrollTo from 'vue-scrollto';
import VueMq from 'vue-mq'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueObserveVisibility from 'vue-observe-visibility'
import VueAnalytics from 'vue-analytics'
import 'swiper/dist/css/swiper.css'
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css'

Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);

Vue.use(VueAnalytics, {
  id: 'UA-40905055-1',
  router
});

Vue.use(VueScrollTo, {
  duration: 700,
  easing: [0, 0, 0.1, 1],
  offset: -100
});

Vue.use(VueMq, {
  breakpoints: {
    tb: 1023,
    pc: Infinity,
  }
});

Vue.use(VueAwesomeSwiper);

Vue.use(VueObserveVisibility);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
